import './Status.scss';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from 'react-plotly.js';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import io from 'socket.io-client';
import { TokenService } from '../../../services/token.service';
import { GristStatus } from '../../../util/model';
import { actionUpdateLayerData } from '../../../redux/action/layerData';
import { RestApi } from '../../../services/restapi.service';
import Moment from "moment";
import { activityStatusAction } from "../../../redux/action/activity";
import GriffinStatus from './griffinstatus/GriffinStatus';
import PSD from './psd/PSD';
import BF from './bf/BF';

export default function Status() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // Update the window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define columns conditionally
  const dispatch = useDispatch();
  const layerData = useAppSelector((state) => state.layerData);
  const Status = layerData.status;

  useEffect(() => {
    const socket = io(window.location.host, {
      reconnectionDelayMax: 10000,
      path: '/api/socket',
      withCredentials: true,
      extraHeaders: {
        'Authorization': `Bearer ${TokenService.getToken()}`,
      }
    });
    socket!.emit('join', 'status');
    socket.on('status', (status: GristStatus) => {
      dispatch(actionUpdateLayerData('status', status) as any)
    });
    socket.io.on('reconnect', (attempt) => {
      socket!.emit('join', 'status');
    });
    return () => {
      socket!.emit('leave', '');
    };
  }, []);

  useEffect(() => {
console.log(Status);
      
  }, [Status.Time]);
  
  return (
    <div className="Status">
      <div className="status-body">
        <Table><TableBody>
          <TableRow>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <GriffinStatus index={0}/>
            </TableCell>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <GriffinStatus index={1}/>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <BF index={0} plotHeight={window.innerWidth * 0.2 * 0.5}/>
            </TableCell>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <BF index={1} plotHeight={window.innerWidth * 0.2 * 0.5}/>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <PSD index={0}/>
            </TableCell>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <PSD index={1}/>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <GriffinStatus index={2}/>
            </TableCell>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <GriffinStatus index={3}/>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <BF index={2} plotHeight={window.innerWidth * 0.2 * 0.5}/>
            </TableCell>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <BF index={3} plotHeight={window.innerWidth * 0.2 * 0.5}/>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <PSD index={2}/>
            </TableCell>
            <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', backgroundColor: 'black'}}>
              <PSD index={3}/>
            </TableCell>
          </TableRow>
        </TableBody></Table>
      </div>
    </div>
  );
}
